// Chamadas
import { authorizationLogin, signUp } from '@/services/api/auth';
import {
    successHandlerLogin,
    checkToken,
    getSubscription,
    getContractor,
    getSupplier,
    getContractorPartner,
    getCrossSalerComplement
} from '@/services/';
import { subscriptionHeader } from '@/services/api/subscriptionHeader';
import { checkViewNewTabEngelinkMarketing, sendViewNewTabEngelinkMarketing } from '@/services/api/notifications';
import {getCountNotificationUnread} from '@/services/api/notifications'
// filtros
import { shortSupplierName } from '@/utils/filters';

import Vue from 'vue';
import VueCookies from 'vue-cookies';
import _ from 'lodash';

// Registro de Cookies
Vue.use(VueCookies);
export const state = {
    user: Vue.$cookies.get('user') != undefined ? Vue.$cookies.get('user') : {},
    canAnswerFeedback:
        Vue.$cookies.get('can_answer_feedback') != undefined ? Vue.$cookies.get('can_answer_feedback') : false,
    ratingUserModal: false,
    supplierData: {
        bonus: '0',
        coins: '0',
        planType: '',
        supplierName: '',
        useCreditCardCountdown: 0,
        supplierState: ''
    },
    userNotification: 0
};
export const mutations = {
    SET_CONTRACTOR_PARTNER(state, partner) {
        Vue.set(state.user, 'partner', partner);
        state.user.partner = partner;
        Vue.$cookies.set('user', state.user);
    },
    SET_TYPE(state, type) {
        Vue.set(state.user, 'type', type);
        state.user.type = type;
        Vue.$cookies.set('user', state.user);
    },
    USER_AUTHENTICATION(state, user) {
        Vue.$cookies.set('user', user);
        state.user = user;
    },
    SET_COMPLEMENT_TYPE(state, complement) {
        if (state.user.type) {
            if (state.user.type.hasContractorProfile == undefined)
                state.user.type = { ...state.user.type, ...complement };
        } else {
            state.user.type = complement;
        }
        Vue.$cookies.set('user', state.user);
    },
    LOGOUT(state) {
        Vue.$cookies.set('user', {});
        Vue.$cookies.set('can_answer_feedback', false);
        state.user = {};
        state.canAnswerFeedback = false;
    },
    SET_PLAN_TYPE_SUPPLIER(state, planType) {
        Vue.set(state.user, 'planType', planType);
        state.user.planType = planType;
        Vue.$cookies.set('user', state.user);
    },
    SET_CAN_ANSWER_FEEDBACK(state, canAnswerFeedback) {
        Vue.set(state, 'canAnswerFeedback', canAnswerFeedback);
        state.canAnswerFeedback = canAnswerFeedback;
        Vue.$cookies.set('can_answer_feedback', state.canAnswerFeedback);
    },
    SET_RATING_USER_MODAL(state, canAnswerFeedback) {
        state.ratingUserModal = canAnswerFeedback;
    },
    SET_SUBSCRIPTION_HEADER(state, subscriptionHeader) {
        state.supplierData.bonus =
            Number(subscriptionHeader.bonusCash) > 0 ? subscriptionHeader.bonusCash.replace('.', ',') : '0';
        state.supplierData.coins =
            Number(subscriptionHeader.engelinkCash) > 0 ? subscriptionHeader.engelinkCash.replace('.', ',') : '0';
        state.supplierData.planType = subscriptionHeader.planName;
        state.supplierData.supplierName = shortSupplierName(subscriptionHeader.supplierTradingName);
        state.supplierData.useCreditCardCountdown = subscriptionHeader.useCreditCardCountdown;
    },
    CLEAR_SUBSCRIPTION_HEADER(state) {
        state.supplierData.bonus = '0';
        state.supplierData.coins = '0';
        state.supplierData.planType = '';
        state.supplierData.supplierName = '';
        state.supplierData.useCreditCardCountdown = 0;
        state.supplierData.isCrossSeller = false;
    },
    CLEAR_USE_CREDIT_COUNTDOWN(state) {
        state.supplierData.useCreditCardCountdown = 0;
    },
    SET_SUBSCRIPTION_HEADER_ATTRIBUTE(state, obj) {
        Vue.set(state.supplierData, obj.attribute, obj.value);
        state.supplierData[obj.attribute] = obj.value;
    },
    SET_COUNT_NOTIFICATION_UNREAD(state, count) {
        state.userNotification = count
    }
};
export const actions = {
    async setUserType({ commit }) {
        const type = await checkToken();
        await commit('SET_TYPE', type);
    },
    async registerUser({ commit, dispatch }, { formData }) {
        const { data, error } = await signUp(formData);
        if (error) {
            return { error };
        } else {
            await commit('USER_AUTHENTICATION', data);
            await successHandlerLogin(data);
            const type = await checkToken();

            await commit('SET_TYPE', type);
            // call action to complement type
            await dispatch('setComplementType');
            return { sucess: 'Logado com Sucesso!' };
        }
    },
    async getUser({ dispatch }, { email, password }) {
        const { data, error } = await authorizationLogin({
            username: '',
            email,
            password
        });

        if (error) {
            return { error };
        } else {
            await dispatch('setUserInformation', data);
            return { sucess: 'Logado com Sucesso!' };
        }
    },
    async setUserInformation({ commit, dispatch }, dataUser) {
        if (dataUser) {
            await commit('USER_AUTHENTICATION', dataUser);
            await successHandlerLogin(dataUser);
        }
        const type = await checkToken();
        await commit('SET_TYPE', type);
        await commit('SET_CAN_ANSWER_FEEDBACK', false);
        // call action to complement type
        await dispatch('setComplementType');
        await dispatch('setContractorPartner');
    },
    async setEngelinkMarketingDashboard({ commit }) {
        try {
            await sendViewNewTabEngelinkMarketing();
            commit('SET_SUBSCRIPTION_HEADER_ATTRIBUTE', {
                attribute: 'engelinkMarketingVisualized',
                value: false
            });
        } catch (e) {
            console.error(e);
        }
    },
    async checkingEngelinkMarketingDashboard({ commit }) {
        try {
            const { hasNew } = await checkViewNewTabEngelinkMarketing();
            commit('SET_SUBSCRIPTION_HEADER_ATTRIBUTE', {
                attribute: 'engelinkMarketingVisualized',
                value: hasNew
            });
        } catch (e) {
            console.error(e);
        }
    },
    async engelinkMarketingClicked({ commit }) {
        commit('SET_SUBSCRIPTION_HEADER_ATTRIBUTE', {
            attribute: 'engelinkMarketingVisualized',
            value: false
        });
    },
    async setContractorPartner({ commit, state }) {
        const data = await getContractorPartner();
        if (data) commit('SET_CONTRACTOR_PARTNER', data);
    },
    async setComplementType({ commit, state }) {
        const [contractorData, supplierData] = await Promise.all([getContractor(), getSupplier()]);
        let subscription = {};
        try {
            const { data, error } = await getSubscription();
            if (!error) {
                subscription = data;
            }
        } catch (e) {
            console.log(e);
        }

        const hasContractorProfile = contractorData.length > 0;
        const contractorType = hasContractorProfile ? contractorData[0].contractorType : '';
        const isSupplierValidated = state.user.type.isSupplier && supplierData[0].isValidated;
        const hasSubscription = !_.isEmpty(subscription);
        const contactNetwork = !_.isEmpty(subscription) ? subscription.contactNetwork : false;
        const isSubscriptionDefault = state.user.type.isSupplier && hasSubscription && subscription.isDefault;

        const complementType = {
            hasContractorProfile: hasContractorProfile,
            isSupplierValidated: isSupplierValidated,
            hasSubscription: hasSubscription,
            isSubscriptionDefault: isSubscriptionDefault,
            contractorType: contractorType
        };

        await commit('SET_COMPLEMENT_TYPE', complementType);
        await commit('SET_SUBSCRIPTION_HEADER_ATTRIBUTE', { attribute: 'contactNetwork', value: contactNetwork });
        return true;
    },
    logout({ commit }) {
        commit('LOGOUT');
        commit('CLEAR_SUBSCRIPTION_HEADER');
    },
    hasUser() {
        return state.user.key ? true : false;
    },
    userToken() {
        return state.user.key ? state.user.key : false;
    },
    setPlanTypeSupplier({ commit }, planType) {
        commit('SET_PLAN_TYPE_SUPPLIER', planType);
    },
    ratingFeedback({ commit }, canAnswerFeedback) {
        commit('SET_CAN_ANSWER_FEEDBACK', canAnswerFeedback);
        commit('SET_RATING_USER_MODAL', canAnswerFeedback);
    },
    ratingFeedbackClose({ commit }) {
        commit('SET_RATING_USER_MODAL', false);
    },
    async setCrossSellerOnHeader({ commit }) {
        // isolar essa action
        try {
            const { isCrossSeller, error } = await getCrossSalerComplement();
            if (!error) {
                await commit('SET_SUBSCRIPTION_HEADER_ATTRIBUTE', {
                    attribute: 'isCrossSeller',
                    value: isCrossSeller
                });
            }
        } catch (e) {
            console.log(e);
        }
    },
    async setSubscriptionHeader({ commit, state, dispatch }) {
        try {
            const [{ canBuyQuotationCreditCard, state }] = await getSupplier();
            commit('SET_SUBSCRIPTION_HEADER_ATTRIBUTE', {
                attribute: 'canBuyQuotationCreditCard',
                value: canBuyQuotationCreditCard
            });
            commit('SET_SUBSCRIPTION_HEADER_ATTRIBUTE', {
                attribute: 'supplierState',
                value: state
            });
        } catch (e) {
            console.error(e);
        }
        try {
            const subscription = await subscriptionHeader();
            commit('SET_SUBSCRIPTION_HEADER', subscription);
            await dispatch('setPlanTypeSupplier', state.supplierData.planType);
            // await dispatch('checkingEngelinkMarketingDashboard');
        } catch (e) {
            console.error(e);
            await dispatch('setPlanTypeSupplier', '');
        }
        await dispatch('setCrossSellerOnHeader');
    },
    setUserCountdown({ commit }) {
        commit('CLEAR_USE_CREDIT_COUNTDOWN');
    },
    async setCountNotificationUnread({ commit }) {
        try {
            const count = await getCountNotificationUnread()
            commit('SET_COUNT_NOTIFICATION_UNREAD', count)
        } catch (e) {
            console.error(e)
        }
    }
};
export const getters = {
    verifyUserType() {
        return state.user.type ? state.user.type : false;
    },
    isSupplier() {
        if (state.user.type) {
            return state.user.type.isSupplier;
        } else {
            return false;
        }
    },
    userType() {
        // isAdmin:false
        // isCondo:false
        // isCondoAdministrator:false
        // isContractor:true
        // isPhysicalPerson:false
        // isRequester:false
        // isSupplier:true
        // isValid:true
        // ************************************************************************************
        // CIVIL_CONSTRUCTION: "civil-construction",
        // CONDOMINUM: "condo",
        // CORPORATIVE: "corporative",
        // PRIVATE_PERSON: "private-person",
        // PROFESSIONAL_BUILDING_MANAGER: "professional-building-manager",
        // RENOVATION_AND_SERVICES: "renovation-and-services",
        // SUPPLIER: "supplier",
        // REQUESTER: "requester",
        // CONDO_ADMINISTRATOR: "condo-administrator"
        if (!state.user.type) return 'guest';
        if (state.user.type.isCondoAdministrator) return 'condo-administrator';
        else if (state.user.type.isCondo) return 'condo';
        else if (state.user.type.isRequester) return 'requester';
        else if (state.user.type.isPhysicalPerson) return 'renovation-and-services';
        else if (state.user.type.isContractor) return 'civil-construction';
        else if (state.user.type.isSupplier) return 'supplier';
    }
};
